//service contracts
import {
	GenericSuccessResponse,
	GetCompanyReviewFormResponseJson,
	GetCompanyReviewFormsResponse,
	PatchCompanyReviewFormRequestJson,
	PostCompanyReviewFormRequest,
	PostCompanyReviewFormResponse,
} from "@performyard/service-contracts";
import { ConvertObjectIdsToString } from "@performyard/utils-isomorphic";

import request from "./internal-base-request";

export type PostCompanyReviewFormResponseJson = ConvertObjectIdsToString<PostCompanyReviewFormResponse>;

export const getCompanyForms = async (searchOptions: {
	search?: string;
	sort?: string;
	direction?: string;
	page?: number;
	limit?: number;
}): Promise<GetCompanyReviewFormsResponse> => {
	let url = `/v1/company/reviews/forms?`;

	if (searchOptions.search) {
		url += `search=${searchOptions.search}`;
	}
	if (searchOptions.sort) {
		url += `&sort=${searchOptions.sort}`;
	}
	if (searchOptions.direction) {
		url += `&direction=${searchOptions.direction}`;
	}
	if (searchOptions.page) {
		url += `&page=${searchOptions.page}`;
	}

	const [response] = await request<GetCompanyReviewFormsResponse>(url);
	return response;
};

export const getCompanyFormByBaseId = async (baseId: string) => {
	const [response] = await request<GetCompanyReviewFormResponseJson>(`/v1/company/reviews/forms/${baseId}`);
	return response;
};

export const postCompanyForm = async ({
	name,
	questions = [],
}: PostCompanyReviewFormRequest): Promise<PostCompanyReviewFormResponseJson> => {
	const [response] = await request<PostCompanyReviewFormResponseJson>(`/v1/company/reviews/forms`, {
		method: "POST",
		body: JSON.stringify({ name, questions }),
	});

	return response;
};

export const patchCompanyForm = async (baseId: string, updates: PatchCompanyReviewFormRequestJson): Promise<any> => {
	const [response] = await request<PatchCompanyReviewFormRequestJson>(`/v1/company/reviews/forms/${baseId}`, {
		method: "PATCH",
		body: JSON.stringify({ ...updates }),
	});

	return response;
};

export const deleteCompanyForm = async (formId): Promise<GenericSuccessResponse> => {
	const [response] = await request<GenericSuccessResponse>(`/v1/company/reviews/forms/${formId}`, {
		method: "DELETE",
	});

	return response;
};
